import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ChunkService } from 'src/app/views/content/chunk/chunk.service';
import { ContentService } from 'src/app/views/content/content.service';

@Component({
  selector: 'app-question-viewer',
  templateUrl: './question-viewer.component.html',
  styleUrls: ['./question-viewer.component.scss'],
  standalone: false,
})
export class QuestionViewerComponent implements OnDestroy {
  AIResponse = '';

  shareData;

  chunkOnEditSubscription = this.chunkService.chunkEditEvent$.subscribe(async ($event: any) => {
    // Logic removed for AI response chunk
  });

  constructor(
    private dialogRef: MatDialogRef<QuestionViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private translate: TranslateService,
    private chunkService: ChunkService,
    private contentService: ContentService
  ) {
    this.AIResponse = dialogData.AIResponse;
    this.shareData = {
      questionID: this.dialogData._id,
      asker: this.dialogData.asker,
    };
  }

  getLanguage() {
    return this.translate.currentLang;
  }

  ngOnDestroy(): void {
    this.chunkOnEditSubscription.unsubscribe();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
